import { useRef, useState } from "react";
import { isNative } from "../../native/capacitor";
import { nativeStart, nativeStop } from "./speechNative";

const WebSR = typeof window !== "undefined" && (window.SpeechRecognition || window.webkitSpeechRecognition);
export const dictationSupported = isNative() || !!WebSR;

// إملاء صوتي: يفضّل التعرّف الأصلي للجهاز داخل التطبيق، ويرجع إلى Web Speech في المتصفح فقط.
export const useDictation = (onResult) => {
  const [listening, setListening] = useState("");
  const rec = useRef(null);
  const buf = useRef("");

  const startWeb = (field, lang) => {
    if (!WebSR) return;
    rec.current?.stop();
    const r = new WebSR();
    r.lang = lang === "ar" ? "ar-SA" : "en-US";
    r.interimResults = false;
    r.maxAlternatives = 1;
    r.onresult = (e) => onResult(field, e.results[0][0].transcript);
    r.onend = () => setListening("");
    r.onerror = () => setListening("");
    rec.current = r;
    setListening(field);
    r.start();
  };

  // ضغطة لبدء الاستماع (تنبض الأيقونة) وضغطة ثانية لإدراج النص الملتقَط.
  const startNative = async (field, lang) => {
    if (listening) {
      await nativeStop();
      if (buf.current) onResult(listening, buf.current.trim());
      const same = listening === field;
      buf.current = "";
      setListening("");
      if (same) return;
    }
    buf.current = "";
    setListening(field);
    try {
      await nativeStart(lang === "ar" ? "ar-SA" : "en-US", (t) => { buf.current = t; });
    } catch {
      setListening("");
    }
  };

  const start = (field, lang) => (isNative() ? startNative(field, lang) : startWeb(field, lang));
  return { listening, start };
};
